var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.as,_vm._g({tag:"component",staticClass:"inline-flex items-center justify-center border border-transparent font-medium disabled:opacity-40 disabled:cursor-not-allowed transition-colors",class:[
    _vm.buttonSize,
    _vm.buttonColor,
    _vm.buttonShape,
    _vm.disabled ? '' : _vm.hoverMutation
  ],attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }